export default {
  brand: 'Basetao Spreadsheet',
  nav: {
    home: 'Início',
    guide: 'Guia de compras',
    categories: 'Categorias',
  },
  buttons: {
    basetaoSpreadsheet: 'Basetao Spreadsheet',
    buyNow: 'Comprar agora',
    readGuide: 'Ler o guia',
    visitMainSite: 'Visitar o site principal',
    browseCategories: 'Explorar categorias',
  },
  lang: {
    label: 'Idioma',
    english: 'English',
    french: 'Français',
    german: 'Deutsch',
    spanish: 'Español',
    portuguese: 'Português',
  },
  footer: {
    tagline: 'Seu recurso independente de Basetao Spreadsheet.',
    disclaimer:
      'Este site é um recurso informativo independente e não é o site oficial da Basetao, salvo indicação explícita em contrário.',
    categoriesTitle: 'Categorias',
    resourcesTitle: 'Recursos',
    guideLink: 'Guia de Basetao Spreadsheet',
    mainSiteLink: 'Site principal',
    rights: 'Todos os direitos reservados.',
  },
  notFound: {
    title: 'Página não encontrada',
    desc: 'A página que você procura pode ter sido movida ou não existe mais. Volte ao início ou visite o site principal para continuar comprando.',
    backHome: 'Voltar ao início',
  },
};